module.exports = __webpack_public_path__ + "static/media/all_atlantic_logo.b73f6fc5.png";